import React, { useState } from "react";

import WarningIcon from "@mui/icons-material/Warning";
import {
  Box,
  Button,
  CircularProgress,
  Portal,
  Typography,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

import Dialog from "@/components/Dialog";
// import Column from "@/components/layout/Column";
import Padding from "@/components/layout/Padding";
import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()({
  deleteDialogPaper: {
    minWidth: 400,
    maxWidth: 400,
  },
  deleteDialogContent: {
    paddingTop: 0,
  },
  deleteDialogIcon: {
    maxHeight: 60,
    fontSize: 60,
    color: colors.secondary,
  },
  deleteDialogTitle: {
    fontWeight: 700,
    fontSize: 28,
    lineHeight: 1,
    color: colors.dark,
    textAlign: "center",
  },
  deleteDialogMessage: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "22px",
    color: colors.gray,
    textAlign: "center",
  },
  deleteDialogButton: {
    minWidth: 125,
  },
  itemIcon: {
    minWidth: 30,
  },
});

type DeleteProps = {
  title: string;
  message: string;
  visible: boolean;
  onClose: () => void;
  onDelete: (id?: string) => void | Promise<void>;
};

const DeleteModal: React.FC<DeleteProps> = ({
  onDelete,
  title,
  message,
  onClose,
  visible,
}) => {
  const { classes } = useStyles();
  const [isDeleting, setIsDeleting] = useState(false);

  const closeDeleteDialog = () => {
    setIsDeleting(false);
    onClose();
  };

  const handleDeleteConfirm = () => {
    setIsDeleting(true);
    onDelete();
    closeDeleteDialog();
  };

  return (
    <>
      <Portal>
        <Dialog
          title={title}
          open={visible}
          onClose={onClose}
          classes={{ paper: classes.deleteDialogPaper }}
          contentClassName={classes.deleteDialogContent}
          content={
            <Box display="flex" flexDirection="column" alignItems="center">
              <div className={classes.deleteDialogIcon}>
                <WarningIcon fontSize="inherit" color="inherit" />
              </div>
              <Box marginBottom={5} />
              <Typography className={classes.deleteDialogTitle}>
                Are you sure?
              </Typography>
              <Box marginBottom={2} />
              <Typography className={classes.deleteDialogMessage}>
                {message}
              </Typography>
            </Box>
          }
          actions={
            <Button
              size="large"
              className={classes.deleteDialogButton}
              onClick={handleDeleteConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? <CircularProgress size="1.6rem" /> : <>Confirm</>}
            </Button>
          }
        />
      </Portal>
    </>
  );
};

export default DeleteModal;
